import { ga_push } from "./analytics";
var urlToShare = "https://z.ynet.co.il/mShort/content/2020/glgltz-international/";

const shareFacebook = () => {
  ga_push("share_events", "Social", "Share From Header", "Facebook")
  var url =
    urlToShare +
    "?utm_source=ynet.co.il&utm_medium=social&utm_campaign=facebook";
  window.open(
    "http://www.facebook.com/share.php?u=" + encodeURIComponent(url),
    "_blank"
  );
};

const shareWhatsapp = () => {
  ga_push("share_events", "Social", "Share From Header", "Whatsapp")
  
  var url =
    urlToShare +
    "?utm_source=ynet.co.il&utm_medium=social&utm_campaign=whatsapp";
  if (window.innerWidth < 768) {
    window.open("whatsapp://send?text=" + encodeURIComponent(url), "_parent");
  } else {
    window.open(
      "https://web.whatsapp.com/send?phone=&text=" + encodeURIComponent(url),
      "_blank"
    );
  }
};

const openNegishut = () => {
  window.document.getElementById("INDmenu-btn").click();
};
export { shareFacebook, shareWhatsapp, openNegishut };
